import { LandingspageData, StoryData } from "@/storyblok/schemas";
import Hero from "../blocks/Hero";
import { exhaustiveSwitchGuard } from "@/lib/util";
import { makeEditable } from "@/storyblok/visual-editor";
import Header from "../base/Header";
import JobOfferIntro from "../blocks/JobOfferIntro";
import TextBlock from "../blocks/TextBlock";
import ContactPerson from "../blocks/ContactPerson";
import WorkAt from "../blocks/WorkAt";
import ApplicationProcess from "../blocks/ApplicationProcess";
import Colleagues from "../blocks/Colleagues";
import Clients from "../blocks/Clients";
import ApplicationForm from "../blocks/ApplicationForm";
import Quote from "../blocks/Quote";
import CollapsibleContent from "../blocks/CollapsibleContent";
import CarreerPath from "../blocks/CarreerPath";
import Footer from "../blocks/Footer";
import JobPostingLD from "../optimization/structured-data/JobPostingLD";
import Spacer from "../blocks/Spacer";
import JobOffersOverview from "../blocks/JobOffersOverview";
import RecruiteeApplicationForm from "../blocks/RecruiteeApplicationForm";

export default function LandingspageStory({
  story,
}: {
  story: StoryData<LandingspageData>;
}) {
  return (
    <>
      <style
        dangerouslySetInnerHTML={{
          __html: `
              body {
                --color-primary: ${story.content.primary_color?.color}
              }
            `,
        }}
      ></style>

      {story.content.job_posting && (
        <JobPostingLD data={story.content.job_posting} />
      )}

      <Header data={story.content} />

      <main
        id="main-content"
        {...makeEditable(story)}
        className={story.content.special_class}
      >
        {story.content.body.map((block) => {
          const component = block.component;

          switch (component) {
            case "hero":
              return <Hero data={block} key={block._uid} />;
            case "text-block":
              return <TextBlock data={block} key={block._uid} />;
            case "job-offer-intro":
              return <JobOfferIntro data={block} key={block._uid} />;
            case "contact-person":
              return <ContactPerson data={block} key={block._uid} />;
            case "work-at":
              return <WorkAt data={block} key={block._uid} />;
            case "application-process":
              return <ApplicationProcess data={block} key={block._uid} />;
            case "colleagues":
              return <Colleagues data={block} key={block._uid} />;
            case "clients":
              return <Clients data={block} key={block._uid} />;
            case "application-form":
              return <ApplicationForm data={block} key={block._uid} />;
            case "recruitee-application-form":
              return <RecruiteeApplicationForm data={block} key={block._uid} />;
            case "quote":
              return <Quote data={block} key={block._uid} />;
            case "collapsible-content":
              return <CollapsibleContent data={block} key={block._uid} />;
            case "carreer-path":
              return <CarreerPath data={block} key={block._uid} />;
            case "spacer":
              return <Spacer data={block} key={block._uid} />;
            case "job-offers-overview":
              return <JobOffersOverview data={block} key={block._uid} />;
            case "footer":
              return <Footer data={block} key={block._uid} />;
            default:
              return exhaustiveSwitchGuard(component, false);
          }
        })}
      </main>
    </>
  );
}
